import { UpdateProjectsAction } from '../actions/ProjectsAction';
import { Projects } from '../../utils/types/Projects';

const initialState: Array<{ docId: string; project: Projects }> = [];

export default function ProjectsReducer(
	state = initialState,
	action: UpdateProjectsAction,
): Array<{ docId: string; project: Projects }> {
	switch (action.type) {
		case 'UPDATE_PROJECTS':
			return Object.assign([], action.payload);

		default:
			return state;
	}
}
